import axios from 'axios'
import { getEnvVar } from '@/assets/js/helpers'

let debugUserId = ''

if (process.env.NODE_ENV !== 'development') {
  debugUserId = null
}

const apiClient = axios.create({
  baseURL: getEnvVar('VUE_APP_API_URL'),
  withCredentials: true
})

export default {
  debugUserId: debugUserId,
  getUser () {
    return apiClient.post('/get-user')
  },
  onboardingShown () {
    return apiClient.post('/onboarding-shown')
  }
}
